import { render, staticRenderFns } from "./AdminAppShow.vue?vue&type=template&id=4ce5a7e6&scoped=true"
import script from "./AdminAppShow.vue?vue&type=script&lang=js"
export * from "./AdminAppShow.vue?vue&type=script&lang=js"
import style0 from "./AdminAppShow.vue?vue&type=style&index=0&id=4ce5a7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5a7e6",
  null
  
)

export default component.exports